const packages = [
	{
		title: "First Lesson Special",
		price: 70,
		priceId: "price_1QkL4lHHC1jWtrw9U8OWg8Of",
		description:
			"Take advantage of our First Lesson Special to start the journey to obtaining your license with a one-hour introductory lesson. This lesson will introduce you to essential driving skills and ACT logbook requirements to achieve Competency Based Training (applicable to ACT Learner license holders) or NSW learner logbook (for NSW license holders), setting a strong foundation for your future lessons. Each lesson will be tailored to your specific needs and logbook requirements, ensuring you gain confidence and skills at your own pace.",
	},
	{
		title: "Single Lesson",
		price: 80,
		priceId: "price_1QkL7rHHC1jWtrw9mS4zyWPE",
		description:
			"Our Single Lesson package provides you with a full hour of dedicated, one-on-one lessons. Each lesson is customized to your needs, ensuring you build confidence and proficiency. All lessons are designed to comply with your driving logbook, helping you progress towards your driver's license.",
	},
	{
		title: "10 Lessons",
		price: 750,
		priceId: "price_1QkL8DHHC1jWtrw9TVv06MhE",
		description:
			"Maximize your learning experience with our 10 Lessons package, providing ten hours of comprehensive driving lessons for $750. This package is ideal for students committed to achieving high proficiency and confidence behind the wheel. Our instructors will guide you through a detailed training plan that meets the logbook requirements, helping you progress towards your license.",
	},
	{
		title: "5 Lessons Pack",
		price: 375,
		priceId: "price_1QkL9WHHC1jWtrw9PyKEpLsG",
		description:
			"Our 5 Lessons package offers five hours of expert teaching for $375. This package is perfect for those looking to make consistent progress. Our structured learning plan complies with your logbook competencies, teaching you the important skills to help you progress towards your driver's license.",
	},
	{
		title: "Refresher Pack (4 Lessons)",
		price: 300,
		priceId: "price_1QkL9yHHC1jWtrw9CnzCsyGl",
		description:
			"Rebuild your driving confidence with our Refresher package, which includes four one-hour lessons. This package is perfect for licensed drivers who want to update their skills or feel more comfortable behind the wheel. Our instructors will assess your current driving abilities and focus on areas that need improvement, ensuring you regain your confidence and driving competence. The Refresher pack is also ideal for students preparing themselves for the one-off government test.",
	},
	{
		title: "Test Prep Lesson (1 hour)",
		price: 85,
		priceId: "price_1QkLBJHHC1jWtrw91Y5RIMWU",
		description:
			"A one-hour instructional lesson that covers a full comprehensive checklist to prepare you for the one-off driving test.",
	},
	{
		title: "Special Test Package",
		price: 170,
		priceId: "price_1QkLBhHHC1jWtrw96rR4kH6V",
		description:
			"This special package includes a one-hour instructional lesson that covers a full comprehensive checklist to prepare you for the one-off driving test. This package includes an additional hour for using the instructor's vehicle for the test.",
	},
];

export default packages;